import { render } from "./StandardV2Layout.vue?vue&type=template&id=53e15b88&scoped=true"
import script from "./StandardV2Layout.vue?vue&type=script&lang=js"
export * from "./StandardV2Layout.vue?vue&type=script&lang=js"

import "./StandardV2Layout.vue?vue&type=style&index=0&id=53e15b88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e15b88"]])

export default __exports__